import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import ButtonLoader from "../ButtonLoader";

const emptyForm = () => ({
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  title: "",
  isActive: true,
  note: "",
});

export default function CustomerContactDialog({ open, loading, onClose, onSubmit, targetLabel }) {
  const [formData, setFormData] = useState(emptyForm);

  useEffect(() => {
    if (!open) setFormData(emptyForm());
  }, [open]);

  const handleChange = (name) => (event) => {
    const value = name === "isActive"
      ? event.target.value === "active"
      : event?.target?.value ?? "";
    setFormData((previous) => ({ ...previous, [name]: value }));
  };

  const handleSubmit = () => onSubmit?.({
    firstName: String(formData.firstName || "").trim(),
    lastName: String(formData.lastName || "").trim(),
    email: String(formData.email || "").trim(),
    phone: String(formData.phone || "").trim(),
    title: String(formData.title || "").trim(),
    isActive: formData.isActive !== false,
    note: String(formData.note || "").trim(),
  });

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>Add Contact</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2} sx={{ pt: 0.5 }}>
          <Typography variant="body2" color="text.secondary">
            Create a new customer contact for {targetLabel}.
          </Typography>
          <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 2 }}>
            <TextField label="First Name" value={formData.firstName} onChange={handleChange("firstName")} fullWidth size="small" />
            <TextField label="Last Name" value={formData.lastName} onChange={handleChange("lastName")} fullWidth size="small" />
            <TextField label="Email" value={formData.email} onChange={handleChange("email")} fullWidth size="small" />
            <TextField label="Phone" value={formData.phone} onChange={handleChange("phone")} fullWidth size="small" />
            <TextField label="Title" value={formData.title} onChange={handleChange("title")} fullWidth size="small" />
            <TextField select label="Status" value={formData.isActive !== false ? "active" : "inactive"} onChange={handleChange("isActive")} fullWidth size="small">
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="inactive">Inactive</MenuItem>
            </TextField>
          </Box>
          <TextField label="Note" value={formData.note} onChange={handleChange("note")} fullWidth size="small" multiline minRows={3} />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading} color="secondary">Cancel</Button>
        <Button onClick={handleSubmit} disabled={loading} color="primary">
          {loading ? <ButtonLoader /> : "Create Contact"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
